module.exports = __webpack_public_path__ + "img/product4.c1370c2d.png";